import { AgGrid, Flex } from "@jsq/ds/core";
import { hasUnlinkSubjectIds } from "~/pages/Compliance/Common/OnboardingStatus/hasUnlinkSubjectIds";
import { OnboardingMenuSlot } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingMenuSlot";
import { OnboardingStatusLabel } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingStatusLabel";
import { OnboardingUnlinkMenu } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingUnlinkMenu";
import { OnboardingViewCaseLink } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingViewCaseLink";
import { resolveOnboardingState } from "~/pages/Compliance/Common/OnboardingStatus/resolveOnboardingState";
import {
  onboardingCell,
  onboardingCellWarning,
} from "~/pages/Compliance/Common/OnboardingStatus/styles_vanilla.css";
import { RowActionsMenu } from "../RowActionsMenu";
import { type RowItem } from "../types";

type Params = { value: RowItem["onboardingStatus"]; data?: RowItem; api?: AgGrid.GridApi };

export const OnboardingStatusRenderer = (params: Params) => {
  if (!params.data) {
    return null;
  }
  const { data } = params;
  const state = resolveOnboardingState(data.onboardingStatus);
  const isActionRequired = state.kind === "action-required";
  const canUnlink = hasUnlinkSubjectIds(data.id, data.id);

  let menu = null;
  if (isActionRequired) {
    menu = <RowActionsMenu clientId={data.id} clientName={data.client ?? ""} />;
  } else if (state.kind === "status" && (canUnlink || data.onboardingCaseId != null)) {
    menu = (
      <>
        {canUnlink && (
          <OnboardingUnlinkMenu
            subjectKind="client"
            subjectId={data.id}
            subjectName={data.client ?? ""}
            arenaId={data.id}
            onUnlinked={() => params.api?.refreshServerSide({ purge: true })}
          />
        )}
        {data.onboardingCaseId != null && (
          <OnboardingViewCaseLink caseId={data.onboardingCaseId} />
        )}
      </>
    );
  }

  return (
    <Flex className={isActionRequired ? onboardingCellWarning : onboardingCell}>
      <OnboardingStatusLabel state={state} />
      {menu && <OnboardingMenuSlot>{menu}</OnboardingMenuSlot>}
    </Flex>
  );
};

export default OnboardingStatusRenderer;
